import { render } from "./CustomerSegment.vue?vue&type=template&id=5faa61c6&scoped=true"
import script from "./CustomerSegment.vue?vue&type=script&lang=js"
export * from "./CustomerSegment.vue?vue&type=script&lang=js"

import "./CustomerSegment.vue?vue&type=style&index=0&id=5faa61c6&lang=scss&scoped=true"

import exportComponent from "/var/www/likvio.se/html/likvio-fe/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5faa61c6"]])

export default __exports__